<!--
 * @Description: 房间显示
 * @Date: 2022-03-16 17:40:28
 * @LastEditTime: 2022-03-29 16:13:06
-->
<template>
  <div class="rtc-container">
    <div class="info-container" :class="$isMobile && 'info-container-mobile'">
      <!-- 本地流区域 -->
      <div v-if="localStream" class="local-stream-container">
        <!-- 本地流播放区域 -->
        <div id="localStream" class="local-stream-content"></div>

        <!-- 本地流操作栏 -->
        <div v-if="isPlayingLocalStream" class="local-stream-control">
          <div class="video-control control">
            <span v-if="!isMutedVideo" @click="muteVideo">
              <svg-icon icon-name="video" class="icon-class"></svg-icon>
            </span>
            <span v-if="isMutedVideo" @click="unmuteVideo">
              <svg-icon icon-name="video-muted" class="icon-class"></svg-icon>
            </span>
          </div>
          <div class="audio-control control">
            <span v-if="!isMutedAudio" @click="muteAudio">
              <svg-icon icon-name="audio" class="icon-class"></svg-icon>
            </span>
            <span v-if="isMutedAudio" @click="unmuteAudio">
              <svg-icon icon-name="audio-muted" class="icon-class"></svg-icon>
            </span>
          </div>
        </div>
      </div>

    </div>

    <!-- 远端流区域 -->
    <div class="remote-container">
      <div v-for="(item) in remoteStreamList" :key="item.getUserId()" :id="item.getUserId()"
        class="remote-stream-container">

      </div>

    </div>


  </div>
</template>

<script>
import rtc from './mixins/rtc.js';
import shareRtc from './mixins/share-rtc.js';
import LibGenerateTestUserSig from '@/utils/audioVideo/lib-generate-test-usersig.min';

export default {
  name: 'compRoom',
  mixins: [rtc, shareRtc],
  props: {
    type: String,
    sdkAppId: Number,
    secretKey: String,
    userId: String,
    roomId: Number,
    cameraId: String,
    microphoneId: String,
    inviteUserSig: String,
  },
  data() {
    return {
      logList: [],
    };
  },
  computed: {
  },
  watch: {
    cameraId(val) {
      this.switchDevice('video', val);
    },
    microphoneId(val) {
      this.switchDevice('audio', val);
    },
  },
  methods: {
    noneLocalStream(){
      document.getElementById("localStream").style.display = "none";
    },

    // 点击【Join Room】按钮
    async handleJoinRoom() {
      console.log('点击【Join Room】按钮=======this.userId',this.userId)
      console.log('点击【Join Room】按钮=======this.userId',this.roomId)
      // debugger
      if (!this.sdkAppId || !this.secretKey) {
        alert(this.$t('Please enter sdkAppId and secretKey'));
        return;
      }
      if (!this.userId || !this.roomId) {
        alert(this.$t('Please enter userId and roomId'));
        return;
      }
      const userSigGenerator = new LibGenerateTestUserSig(this.sdkAppId, this.secretKey, 604800);
      this.userSig = userSigGenerator.genTestUserSig(this.userId);
      await this.initClient();
      await this.join();
      await this.initLocalStream();
      await this.playLocalStream();
      await this.publish();
    },
    async handleJoinRoomYY() {
      if (!this.sdkAppId || !this.secretKey) {
        alert(this.$t('Please enter sdkAppId and secretKey'));
        return;
      }
      if (!this.userId || !this.roomId) {
        alert(this.$t('Please enter userId and roomId'));
        return;
      }
      const userSigGenerator = new LibGenerateTestUserSig(this.sdkAppId, this.secretKey, 604800);
      this.userSig = userSigGenerator.genTestUserSig(this.userId);
      await this.initClient();
      await this.join();
      await this.initLocalStream();
      await this.playLocalStream();
      await this.publish();
      await this.closeVedio();
    },

    // 点击【Publish】按钮
    async handlePublish() {
      await this.publish();
    },

    // 点击【Unpublish】按钮
    async handleUnpublish() {
      await this.unPublish();
    },

    // 点击【Leave Room】按钮
    async handleLeave() {
      await this.leave();
    },
    // 显示成功的 Log
    addSuccessLog(log) {

      console.log(log);
    },

    // 显示失败的 Log
    addFailedLog(log) {
      console.log(log);
    },
    reportSuccessEvent(name) {
      this.$aegis.reportEvent({
        name,
        ext1: `${name}-success`,
        ext2: 'webrtcQuickDemoVue2',
        ext3: this.sdkAppId,
      });
    },
    reportFailedEvent(name, error, type = 'rtc') {
      this.$aegis.reportEvent({
        name,
        ext1: `${name}-failed#${this.roomId}*${type === 'share' ? this.shareUserId : this.userId}*${error.message}`,
        ext2: 'webrtcQuickDemoVue2',
        ext3: this.sdkAppId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .rtc-container {
  .label {
    margin: 14px 0 6px;
    text-align: left;
    font-weight: bold;
  }

  .control-container {
    text-align: left;
    margin-bottom: 10px;

  div:not(:nth-last-child(1)) {
    margin-bottom: 10px;
  }

  .button:not(:first-child) {
    margin-left: 2px;
  }
  }

  .invite-link-container {
    width: 100%;
    color: #084298;
    background-color: #cfe2ff;
    position: relative;
    padding: 10px 16px;
    margin-bottom: 16px;
    border: 1px solid #b6d4fe;
    border-radius: 0.25rem;

  .invite-input {
    margin-top: 10px;
  }

  .invite-btn {
    display: flex;
    cursor: pointer;
  }
  }

  .info-container {
    width: 100%;
    display: flex;
    justify-content: space-between;

  .log-container {
    flex-grow: 1;
    border: 1px solid #dddddd;
    height: 360px;
    padding: 10px;
    margin-right: 16px;
    overflow-y: scroll;

  .log-label {
    margin: 0 0 6px;
    font-weight: bold;
  }

  .log-state {
    display: inline-block;
    margin-right: 6px;
  }

  >div {
    font-size: 12px;
  }
  }

  .local-stream-container {
    width: 480px;
    height: 360px;
    position: relative;
    flex-shrink: 0;

  .local-stream-content {
    width: 100%;
    height: 100%;
  }

  .local-stream-control {
    width: 100%;
    height: 30px;
    position: absolute;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /*padding: 0 10px;*/

  .control {
    margin-left: 10px;
  }

  .icon-class {
    color: #fff;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
  }
  }
  }

  .info-container-mobile {
    display: block;

  .log-container {
    margin-right: 0;
  }

  .local-stream-container {
    width: 480px;
    height: 360px;
    margin-top: 10px;
  }
  }

  .remote-container {
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;

  .remote-stream-container {
    width: 480px;
    height: 360px;
    margin: 0 10px 10px 0;
  }
  }
  }
</style>

